import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { TrendingProductEnriched } from "@/lib/contentful/trendingProducts";
const FIVE_MINUTES_MS = 5 * 60_000;
export const trendingProductsQueryKey = ["contentful", "trendingProducts"] as const;
async function fetchTrendingProducts(): Promise<TrendingProductEnriched[]> {
  const response = await fetch("/api/contentful/trending-products");
  if (!response.ok) {
    throw new Error(`trending products ${response.status}`);
  }
  return response.json();
}
export function useTrendingProducts() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: trendingProductsQueryKey,
      queryFn: fetchTrendingProducts,
      staleTime: FIVE_MINUTES_MS
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}